import { ValidatorFn } from '@angular/forms';

const ageOffset = 18;

export const minimumAgeValidator: ValidatorFn = (control) => {
  const value = control.value;
  const createErrorMessage = (message: string) => ({ minimumAge: { message } });

  if (!value) {
    return null;
  }

  const inputDate = new Date(value);
  const eighteenYearsAgo = new Date();
  eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - ageOffset);

  if (inputDate > eighteenYearsAgo) {
    return createErrorMessage('Age has to be 18 or older');
  }

  return null;
};
